pure virtual function void set_print_context(uvm_agent print_context);
{{#with configHandle}}
pure virtual function void update_variables({{ type }} {{ identifier }});
{{/with}}
